import { useRef, useEffect } from 'react';
import { resizeCanvas, resizeCanvasToDisplaySize } from './util'

const BackgroundCanvas = ({ preRenderBackground }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        resizeCanvas(canvas);
        resizeCanvasToDisplaySize(canvas);
        
        const drawBackground = (ctx) =>{
            const bgImage = preRenderBackground(ctx);
            ctx.putImageData(bgImage, 0, 0);
        }

        drawBackground(context)

        return () => {
            console.log('background unmounted')
            context.clearRect(0, 0, canvas.width, canvas.height);
        };

    }, [preRenderBackground]);

    return <canvas ref={canvasRef} className="background-canvas eq-canvas" />;
};

export default BackgroundCanvas;